import { createReducer } from '@reduxjs/toolkit';

import { type RequestMeta, skipRequest } from 'Core/actions/request';
import { setResponse } from 'Core/actions/response';
import { getRequestMeta } from 'Core/reducers/common';

// Explicit Pick<> instead of Omit<> keeps the stored SearchOptions shape in
// sync with `searchOptionsSelector`. Adding a new RequestMeta flag no longer
// silently extends the persisted options — you must add it to both places.
export type SearchOptions = Pick<
  RequestMeta,
  | 'allowSearchSameAsUri'
  | 'fromUri'
  | 'goToSearchPage'
  | 'ignoreLocalPreselection'
  | 'mayDiscardValue'
  | 'onInit'
  | 'stayOnPage'
  | 'pathname'
>;

export const searchOptionsSelector = (options: Partial<RequestMeta>): SearchOptions => ({
  allowSearchSameAsUri: options.allowSearchSameAsUri,
  fromUri: options.fromUri,
  goToSearchPage: options.goToSearchPage,
  ignoreLocalPreselection: options.ignoreLocalPreselection,
  mayDiscardValue: options.mayDiscardValue,
  onInit: options.onInit,
  stayOnPage: options.stayOnPage,
  pathname: options.pathname,
});

const initState: SearchOptions = {};

export default createReducer(initState, (builder) =>
  builder
    .addCase(setResponse, () => initState)
    .addCase(skipRequest, () => initState)
    .addDefaultCase((state, action) => {
      const meta = getRequestMeta(action);
      const { sendRequest, ...searchOptions } = meta;
      return sendRequest ? searchOptionsSelector(searchOptions) : state;
    }),
);
